import * as React from "react";

import { SimpleTableViewStyle } from "./simple-table-view-style";
import { SimpleTableRowStyle } from "generator/components/simple-table-types";
import Img from "../../smart/img/img";
import { isEmptyOrUndefinedish } from "common/Support";
import Checkbox from "../../smart/checkbox/checkbox";
import { getNamedIcon } from "common/named-icons";
import classNames from "classnames";

export interface SimpleTableRowDescription {
    label: string;
    value: string | boolean;
    style: SimpleTableRowStyle;
    action?: (handled: boolean) => void;
    targetURL?: string;
}

interface Props {
    readonly title: string | undefined;
    readonly footer: string | undefined;
    readonly rows: readonly SimpleTableRowDescription[];
    readonly allowWrapping?: boolean;
}

class SimpleTableImpl extends React.PureComponent<Props> {
    public render(): React.ReactNode {
        const { title, footer, rows, allowWrapping = false } = this.props;

        return (
            <SimpleTableViewStyle data-test="app-simple-table" className={classNames({ allowWrapping })}>
                {title !== undefined && <div className="sts-title">{title}</div>}
                {rows.map((r, i) => {
                    const labelFor = `app-st-row-value-${i}`;
                    const label = (
                        <label htmlFor={labelFor} data-test="app-st-item-label" className="sts-label">
                            {r.label}
                        </label>
                    );
                    let value: React.ReactNode;

                    switch (r.style) {
                        case SimpleTableRowStyle.Link:
                            value = (
                                <div id={labelFor} data-test="app-st-item-link" className="sts-value link">
                                    {r.value}
                                </div>
                            );
                            break;
                        case SimpleTableRowStyle.Image:
                            value = (
                                <Img
                                    id={labelFor}
                                    data-test="app-st-item-image"
                                    className="sts-value image"
                                    src={r.value as string}
                                />
                            );
                            break;
                        case SimpleTableRowStyle.Checkbox:
                            value = (
                                <div id={labelFor} data-test="app-st-item-checkbox" className="sts-checkbox-wrap">
                                    <Checkbox
                                        disablePadding={true}
                                        checked={r.value as boolean}
                                        onChanged={() => undefined}
                                        isEnabled={true}
                                    />
                                </div>
                            );
                            break;
                        case SimpleTableRowStyle.Emoji:
                            value = (
                                <div id={labelFor} data-test="app-st-item-emoji" className="sts-value emoji">
                                    {r.value}
                                </div>
                            );
                            break;
                        case SimpleTableRowStyle.None:
                            value = (
                                <div id={labelFor} data-test="app-st-item-value" className="sts-value text">
                                    {r.value}
                                </div>
                            );
                            break;
                        case SimpleTableRowStyle.PushScreen:
                            const Chevron = getNamedIcon("chevronRight");
                            value = (
                                <div id={labelFor} data-test="app-st-item-chevron" className="sts-value link">
                                    <div>{r.value}</div>
                                    <div className="chevron-hack">
                                        <Chevron />
                                    </div>
                                </div>
                            );
                            break;
                    }

                    const content = (
                        <>
                            {label}
                            {value}
                        </>
                    );

                    const onClick = () => {
                        if (r.action !== undefined) {
                            r.action(true);
                        }
                    };

                    if (r.targetURL !== undefined) {
                        return (
                            <a
                                className="sts-row click"
                                href={r.targetURL}
                                onClick={onClick}
                                target="_blank"
                                rel="noopener noreferrer">
                                {content}
                            </a>
                        );
                    }
                    return (
                        <div key={i} className={"sts-row" + (r.action === undefined ? "" : " click")} onClick={onClick}>
                            {content}
                        </div>
                    );
                })}
                {!isEmptyOrUndefinedish(footer) && <div className="sts-footer">{footer}</div>}
            </SimpleTableViewStyle>
        );
    }
}

const SimpleTableView = SimpleTableImpl;
export default SimpleTableView;
